import { h, Host } from "@stencil/core";
import { ListVariant } from "./list-variant.enum";
export class List {
    constructor() {
        this.variant = ListVariant.Default;
    }
    uxListElement;
    validateChildNodes() {
        // @ts-expect-error Check for typing
        const slottedElements = this.uxListElement.shadowRoot.querySelector("slot").assignedNodes();
        if (slottedElements.some((i) => i.nodeName !== "UX-LIST-ITEM" && i.nodeName !== "#text")) {
            throw Error("Invalid component detected: Please ensure only 'ux-list-item' components are inserted into this slot.");
        }
    }
    render() {
        return (h(Host, { key: '775ccbdcad052e6874da688b890e0824b227c7a9', variant: this.variant }, h("ul", { key: 'c2bcdb665c620daf3b89d9bffeb1fd7e0da85861' }, h("slot", { key: 'e7c2eebb6927a82407998bf404e4dacda686daf6', onSlotchange: () => this.validateChildNodes() }))));
    }
    static get is() { return "ux-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["list.css"]
        };
    }
    static get properties() {
        return {
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"default\" | \"square\" | ListVariant",
                    "resolved": "\"default\" | \"square\" | ListVariant.Default | ListVariant.Square",
                    "references": {
                        "ListVariant": {
                            "location": "import",
                            "path": "./list-variant.enum",
                            "id": "src/components/list/list-variant.enum.ts::ListVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Represents the variant of the list."
                },
                "attribute": "variant",
                "reflect": false,
                "defaultValue": "ListVariant.Default"
            }
        };
    }
    static get elementRef() { return "uxListElement"; }
}
//# sourceMappingURL=list.js.map
